interface MarketHeroCardProps {
  domain: string;
  containerStyle: React.CSSProperties | undefined;
  avatarUrl: string | undefined;
  backgroundUrl: string;
  walletAddress: string;
}

const defaultContainerStyle: React.CSSProperties = {
  position: "absolute",
  top: 40,
  left: -12,
  width: "458.31px",
  height: "200.13px",
  background: "#1E1D1D",
  boxShadow: "5px 15px 30px 10px rgba(38, 14, 110, 0.9)",
  borderRadius: "27.0054px",
  flex: "none",
  order: 3,
  flexGrow: 0,
  zIndex: 0,
  color: "#FFFFFF",
  fontSize: "24px",
  overflow: "hidden",
};

const xxx: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  padding: "30px",
  paddingBottom: "45px",
  gap: 5,
};

const MarketHeroCard: React.FC<MarketHeroCardProps> = ({
  domain,
  containerStyle,
  backgroundUrl,
  avatarUrl,
  walletAddress
}) => {
  return (
    <div
      style={{
        ...defaultContainerStyle,
        ...containerStyle,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "30px",
          paddingBottom: avatarUrl ? "45px" : "30px",
          gap: 5,
        }}
      >
        <div>{domain}</div>
        <div style={{ fontSize: "10px", color: "rgba(255, 255, 255, 0.5)" }}>
          {walletAddress}
        </div>
      </div>
      {avatarUrl && (
        <div
          style={{
            backgroundSize: "cover",
            backgroundImage: `url("${avatarUrl}")`,
            top: 90,
            left: 30,
            position: "absolute",
            borderRadius: 10000,
            height: 60,
            width: 60,
            backgroundColor: "#FFFFFF",
          }}
        ></div>
      )}
      <div
        style={{
          backgroundSize: 'cover',
          width: "100%",
          height: "100%",
          backgroundColor: "#FFFFFF",
          backgroundImage: `url("${backgroundUrl}")`,
        }}
      ></div>
    </div>
  );
};

export default MarketHeroCard;
